import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http.js'

export const regionList    = (params = '') => Http.get(`/admin/regions${serialize(params)}`)
export const regionCreate  = (params = '') => Http.post('/admin/regions', params)
export const regionByID    = (id)          => Http.get(`/admin/regions/${id}`)
export const regionUpdate  = (params = '') => Http.put(`/admin/regions/${params.id}`, params)
export const regionDestroy = (params = '') => Http.delete(`/admin/regions/${params.id}`)
